import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider,
  CircularProgress,
  Alert,
} from "@mui/material";
import axios from "axios";
import api from "../../utils/api";

const PredefinedListPage = () => {
  const [lists, setLists] = useState([]);
  const [newListName, setNewListName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchLists = async () => {
    try {
      setLoading(true);
      const res = await api.get("/job-list");
      setLists(res.data);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch predefined lists.");
    } finally {
      setLoading(false);
    }
  };

  const handleAddList = async () => {
    if (!newListName.trim()) {
      setError("List name cannot be empty.");
      return;
    }

    try {
      setError("");
      const res = await api.post("/job-list", { name: newListName.trim() });
      setLists([...lists, res.data]);
      setNewListName("");
    } catch (err) {
      console.error(err);
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError("Error adding predefined list.");
      }
    }
  };

  useEffect(() => {
    fetchLists();
  }, []);

  return (
    <Box sx={{ maxWidth: 600, mx: "auto", mt: 5 }}>
      <Typography variant="h5" gutterBottom>
        Predefined Lists
      </Typography>

      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Add New Job List
        </Typography>
        <Box sx={{ display: "flex", gap: 2 }}>
          <TextField
            label="List Name"
            variant="outlined"
            fullWidth
            value={newListName}
            onChange={(e) => setNewListName(e.target.value)}
          />
          <Button variant="contained" onClick={handleAddList}>
            Add
          </Button>
        </Box>
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Existing Job Lists
        </Typography>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <CircularProgress />
          </Box>
        ) : (
          <List>
            {lists.map((item, index) => (
              <React.Fragment key={item._id || index}>
                <ListItem>
                  <ListItemText primary={item.name} />
                </ListItem>
                {index < lists.length - 1 && <Divider />}
              </React.Fragment>
            ))}
            {lists.length === 0 && (
              <Typography variant="body2" color="text.secondary">
                No predefined lists found.
              </Typography>
            )}
          </List>
        )}
      </Paper>
    </Box>
  );
};

export default PredefinedListPage;
